import { H2 } from "@sellar-io/components";
import { useNavigate } from "react-router";
import { NavigationBarMenu } from "../../components/navigation/NavigationBar";
import { PageContainer } from "../../components/pageContainer/PageContainer";
import { LOGIN } from "../../constants/routes";
import { useFirebaseUser } from "../../hooks/useFirebaseUser.shared";

export function VerificationEmailSent() {
  const navigate = useNavigate();

  const { auth } = useFirebaseUser();

  return (
    <>
      <NavigationBarMenu title={"Verify your email address"} />
      <PageContainer padding={true}>
        <H2 className={"mb-5 text-center"}>Verify your email address</H2>
        <div>
          Please verify your account. An email has been sent to your inbox
        </div>
        <br />
        <div>
          Didn't get the email? Try checking your spam folder or{" "}
          <u>
            <span
              style={{ color: "blue", cursor: "pointer" }}
              onClick={() => {
                auth.signOut().then(() => navigate(LOGIN));
              }}
            >
              log back in again
            </span>
          </u>{" "}
          to send another verification email.
        </div>
      </PageContainer>
    </>
  );
}
